var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLove = function SvgLove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24 0H0v24h24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 10.608C16.22 5.272 13.603 5 12.736 5c-.866 0-.914.734-.914.954 0 2.61-2.822 4.654-2.822 4.654v7.399a.999.999 0 0 0 1 .999L16.615 19c.537 0 .974-1.382.974-1.382C19 12.905 19 11.503 19 11.503c0-.973-.954-.895-.954-.895H14.75Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11H6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3v-7a1 1 0 0 0-1-1Z",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
};
export default SvgLove;